import { render, staticRenderFns } from "./ColumnsConfig.vue?vue&type=template&id=edf4dd40&"
import script from "./ColumnsConfig.vue?vue&type=script&lang=js&"
export * from "./ColumnsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports